import React from 'react';
import Swal from "sweetalert2";
import { useHistory } from 'react-router-dom';

// Material-UI
import {Button, Container, Grid, makeStyles, Paper, Typography } from "@material-ui/core";
import TextField from '@material-ui/core/TextField';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';
// Components
import Navbar from '../components/NavbarTitle';
import Background from "../components/BackgroundPattern";
import Countdown from "../components/CountdownSoal";
import Footer from "../components/Footer";
// Data
import DataSoalPretestPG from '../data/DataSoalPretestPG';

const useStyles = makeStyles((theme) => ({
  paper: {
    marginTop: theme.spacing(3),
    padding: theme.spacing(5),
  },
  button: {
    display: "block",
    margin: "auto",
    marginTop: theme.spacing(2)
  }
}));

const TitleSoal = ({ classes }) => {
  return (
    <Grid item xs={9} md={6}>
      <Paper className={classes.paper} elevation={3} style={{height: 80}}>
          <Typography variant="h4" gutterBottom>
            {"Soal Latihan - Pretest"}
          </Typography>
          <Typography variant="subtitle2">
            {"KSR PMI UNIT UNJ Angkatan XVIII Tahun 2020"}
          </Typography>
      </Paper>
    </Grid>
  )
}

const SoalPretestPG = ( {classes} ) => {
  const [value, setValue] = React.useState();
  const handleChange = (event) => {
    console.log("event", event.target.value)
    setValue(event.target.value);
  };

  const soalPretestPG = DataSoalPretestPG.map((data) => (
    <Grid item xs={12} md={8} key={data.id}>
      <Paper className={classes.paper} elevation={3}>
        <FormControl component="fieldset">
          <FormLabel>
            <Typography variant="h6">
              {data.soal}
            </Typography>
          </FormLabel>
          <RadioGroup value={value} onChange={handleChange}>
            <FormControlLabel value={data.jawaban1} control={<Radio color="primary"/>} label={data.jawaban1} />
            <FormControlLabel value={data.jawaban2} control={<Radio color="primary"/>} label={data.jawaban2} />
            <FormControlLabel value={data.jawaban3} control={<Radio color="primary"/>} label={data.jawaban3} />
            <FormControlLabel value={data.jawaban4} control={<Radio color="primary"/>} label={data.jawaban4} />
          </RadioGroup>
        </FormControl>
      </Paper>
    </Grid>
  ))
  return (
    soalPretestPG
  )
}

const SoalPretestEssai = ({classes}) => {
  return (
    <Grid item xs={12} md={8}>
      <Paper className={classes.paper} elevation={3}>
        <FormControl component="fieldset">
          <FormLabel>
            <Typography variant="h6" gutterBottom>
              {"Kondisi Penderita seperti apa yang membutuhkan tindakan RJP? Lalu jelaskan apa tujuan tindakan RJP tersebut !"}
            </Typography>
          </FormLabel>
          <TextField
            id="soal-essai"
            label="Jawab"
            multiline
            rows={4}
            defaultValue=""
            variant="outlined"
          />
        </FormControl>
      </Paper>
    </Grid>
  )
}

const ButtonSubmit = ({classes}) => {
  const history = useHistory();
  const onSubmit = () => {
    return (
      Swal.fire({
        title: 'Kamu yakin ingin mengakhiri ujian?',
        showDenyButton: true,
        showCancelButton: true,
        confirmButtonText: `Ya`,
        cancelButtonText: `Tidak`,
      }).then((result) => {
        if (result.isConfirmed) {
          Swal.fire('Jawaban Tersimpan!', 'Hasil Ujian akan muncul pada tabel Nilai Pelatihan ^_^', 'success')
          history.push('/user/beranda')
        } else if (result.isDenied) {
          Swal.fire()
        }
      })
    )
  }

  return (
    <Grid item xs={12} sm={8}>
      <Button
        className={classes.button}
        type="submit"
        variant="contained"
        color="primary"
        size="large"
        onClick={onSubmit}
      >
        {"Selesai"}
      </Button>
    </Grid>
  )
}

const UserSoalPretestMulai = () => {
  const classes = useStyles();

  return (
    <section id="soal-pretest">
      <Background/>
      <Navbar title="PCAB KSR PMI UNIT UNJ"/>
        <Container>
          <Grid container justify="center">
            <TitleSoal classes={classes}/>
            <Countdown/>
            <SoalPretestPG classes={classes}/>
            <SoalPretestEssai classes={classes}/>
            <ButtonSubmit classes={classes}/>
          </Grid>
        </Container>
      <Footer/>
    </section>
  )
}

export default UserSoalPretestMulai
